/* Custom Drops - trust row in the social band.
   Three plain promises under the social buttons. Injected rather than
   hard-coded into the section so the section schema stays clean, and
   guarded so it can never double-insert. */
(function () {
  function boot() {
    var body = document.querySelector('.cdsoc__body');
    if (!body || body.querySelector('.cdsoc__trust')) return;

    var items = [
      'Printed &amp; stitched in the UK',
      'Free UK delivery over £69.99',
      'Free digital proof before we print'
    ];

    var row = document.createElement('div');
    row.className = 'cdsoc__trust';
    row.innerHTML = items.map(function (t) {
      return '<span class="cdsoc__trustitem"><span class="cdsoc__tick" aria-hidden="true">✓</span>' + t + '</span>';
    }).join('');

    var club = body.querySelector('.cdsoc__club');
    if (club) { body.insertBefore(row, club); } else { body.appendChild(row); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
